export default __webpack_public_path__ + "assets/minus.aa5cce41.svg";